module.exports={
    btn:{
        tips_reelect_btn:"New Image",
        cancel_btn:"Cancel",
        tips_continue_dispose:"Upscale Supported Images",
        tips_return:"New Image",
        tips_upgrade:"Upgrade",
        tips_yes:"OK",
        delete:"Delete",
        download:"Save",
        upload_image:"Upload Images",
        new_image:"New Image",
        save_all:"Save All",
        cancel:"Cancelling",
        save:"Save",
        view_comparison:"View Comparison",
        hide_comparison:"Hide Comparison",
        previous:"Previous",
        next:"Next",
        continue_download:"Save Images with Watermarks",
        present:"Apply to This Image",
        all_wait:"Apply to Images in Waiting",
        all:"Apply to All Images",
        history:"History",
        login:"Login",
    },
    tips:{
        please_upgrade:"Your current plan doesn't support uploading or upscaling images in batches. Please upgrade it to enjoy more benefits.",
        errorlistinfo:"XXX images are selected. XXX images are supported, but XXX images are unsupported. The following are unsupported images:",
        max:"Exceed the maximum image size limit of 10MB!",
        max_size:"Exceed the maximum image side length limit of 4096px!",
        continue_dispose:"Upscale Supported Images",
        please_multiple:"Please select the magnification.",
        max_multiple:"* Your image will be enlarged to 4K at most (the longest side won't exceed 4096px).",
        title:"Name",
        reasons:"Reasons",
        upload_type:"Not Supported",
        used_up:"The number of saving HD images without watermarks has been used up. Please upgrade your account. Or you can save HD images with watermarks.",
        edit_multiple:"There are multiple images uploaded. Please select images that you want to change the magnification. After selecting, these images will be upscaled again to the new magnification.",
        download_confirm:"Some images are still being processed. Are you sure to save all upscaled images? When you save the same image repeatedly, your number of saving images won't be deducted again.",
        waiting_save:"Some images are still being processed. Please save later.",

    },
    header:{
        title:"Aiseesoft Image Upscaler Online",
        hd:" HD image(s)",
        watermarks:"without watermarks can be downloaded at present.",
        view_details:"View Details",
        loading:"Loading…",
    },
    content:{
        failed:"Failed",
        completed:"Completed",
        processing:"Processing",
        img_processing:"Processing…",
        img_rendering1:"Your image has been upscaled.",
        img_rendering2:"We are working on rendering the high quality image for preview, please wait...",
        img_failed:"Failed to Process",
        uploading:"Uploading",
        img_uploading:"Uploading…",
        wait_upoading:"Waiting to upload…",
        waiting:"Waiting",
        img_waiting:"Waiting…",
        empty:"Empty",
        magnification:"Upscale To:",
        drop:"Or drop your image files here to upscale and enhance! ",
        original:"Original:",
        output:"Output:",
        no_watermark:"After saving, the image has no watermark.",
    },
    banner_msg:"Pick a Plan for Image Upscaler",
    monthly:"MONTHLY",
    lifetime:"LIFETIME",
    choose_plan:"Choose your plan based on the number of images",
    return_home:"Congratulations! You have upgraded successfully. Please return to the home page and use this product.",
    congratulations:"Congratulations! You have upgraded successfully. The benefits have been bound to the e-mail address you left while upgrading. Please use the account registered or linked to the e-mail address to ",
    login_benefits:"login for using benefits",
    no_registered:". If you haven't registered or linked an account with the e-mail address, please ",
    register_account:"use the e-mail address to register an account",
    other_accounts:" or link other accounts to this e-mail address for using benefits.",
    btn_close:"Close",
    free:"Free",
    btn_get_started:"Get Started",

    upscale_images:"Upscale images",
    up_to:"Up to ",
    per_image:" per image",
    resolution_of:"Up to resolution of ",
    default_level:"Upscale images in default level",
    image_downloads:"2 HD image downloads without watermark",
    unlimited_image:"Unlimited image downloads with watermark",
    SHA256_encryption:"SHA256 encryption technique",
    mon:"Monthly",
    images:"images",
    high_resolution:" with high-resolution quality",
    tax_incl:"Tax incl.",
    image:"image",
    secure_checkout:"Secure Checkout",
    everything:"Everything in Free, and",
    upscaling_levels:"All upscaling levels can be selected",
    unlimited_image_without:"Unlimited image downloads without watermark",
    viewable_editing:"Viewable editing history is valid for ",
    days:" days",
    high_level:"High-level",
    priority_processing:" priority processing",
    left:"Lifetime",
    resolution:" resolution",


    "history_will":"Will expire after",
    "history.days":"Day(s)",
    "history.hours":"hours",
    "expired":"Expired",
    "access_to":"With the free trial, you can only",
    "pricing.upload_images":"Upload images",
    "pricing.under":"under",
    "pricing.images":"images",
    "pricing.without_watermark":"without watermark",
    "pricing.process_images":"Process images up to",
    "pricing.pixels":"pixels",
    "pricing.enjoy_limited":"Enjoy limited upscale grades",
    "pricing.download":"Download",
    "pricing.HD_images":"HD images without watermark",
    "pricing.and_you":"And you may suffer from",
    "pricing.slow_upscaling":"slow upscaling",
    "pricing.lower_priority":"lower priority",
    "pricing.without":"without watermarker",
    "pricing.tax":"Tax is included in the selling price and will be calculated automatically based on your country and region. In the shopping cart, you can see the detailed tax amount. Your final payment amount shall be the same as the displayed price.",
    "pricing.you_can":"With subscription, you can",
    "pricing.up_to":"Upload images up to",
    "pricing.upscale_images":"Upscale images with",
    "pricing.no_watermark":"no watermark",
    "pricing.enhance":"Enhance",
    "pricing.or_more":"images or more",
    "pricing.in_batch":"in batch",
    "pricing.enlarge_images":"Enlarge images in",
    "pricing.and":"and",
    "pricing.times_with":"times with no limit",
    "pricing.enjoy":"Enjoy",
    "pricing.of_history":"of history storage time",
    "pricing.experience":"Experience",
    "pricing.fast_upscaling":"fast upscaling",
    "pricing.higher_priority":"higher priority",
    "pricing.early_access":"Early access to new features",
    "pricing.cancel_anytime":"Cancel anytime",
    "pricing.lifetime_license":"With lifetime license, you can",
    "pricing.and_there":"And there will be",
    "pricing.no_expiration":"no expiration date",
    "pricing.unless":"unless you run out all upscales",
    "buynow.pop.credit":"credit",
    "buynow.pop.credits":"credits",

    "isUnderequityTip_msg1":"You have selected {%} images for batch processing, and there aren't enough remaining benefits, You still need {%} credits (currently, there are {%} credits left), If you need to process, please purchase benefits to continue processing the images.",
    "isUnderequityTip_msg2":"You have selected {%} images for batch processing, and there aren't enough remaining benefits, You still need {%} credits (currently, there are {%} images of benefits left), If you need to process, please purchase benefits to continue processing the images.",
    "isUnderequityTip_msg3":"You have selected {%} images for batch processing, and there aren't enough remaining benefits, You still need {%} credits (currently, there are {%} credits, {%} images of benefits left), If you need to process, please purchase benefits to continue processing the images.",
    "btn_buy_now":"Buy Now",
    "isEquityDepletionTip_msg":"Your current benefits have been used up, Please purchase the benefits for batch processing.",


}